export default "__VITE_ASSET__CfXvPSSK__"